import type {
    ErstelleNutzerRequest,
    SaveHortProCredentialsRequest,
    BestaetigeNutzerEmailRequest,
    IsConfirmationTokenValidRequest,
    Nutzer,
    PasswortZuruecksetzenAnfrageRequest,
    PasswortAendernRequest
} from '@/js/model'

// TODO: durch generierte Typen aus '@/js/model' ersetzen, sobald `composer create-api-client` gelaufen ist.
export interface TestHortProCredentialsRequest {
    hortProUsername?: string
    hortProPassword?: string
    nutzer?: string
}

export type TestHortProFehler = 'credentials_invalid' | 'unreachable' | 'nutzer_ohne_credentials'

export interface TestHortProCredentialsResponse {
    verbunden: boolean
    kindernamen: string[]
    fehler: TestHortProFehler | null
}

export const useNutzerService = () => {
    const fetch = useFetch({ baseURL: '/api/nutzende' })

    const getAllNutzers = (fetchParams: FetchParams) => {
        const fetch = useFetchItems({ baseURL: '/api/nutzende' })

        return fetch.get<any>({ fetchParams })
    }

    const getNutzerById = (id: string) => {
        return fetch.get<Nutzer>({ url: id })
    }

    const saveHortProCredentials = async (request: SaveHortProCredentialsRequest): Promise<Nutzer> => {
        return await useFetch({
            baseURL: '/api/nutzende/save-hort-pro-credentials'
        }).post<Nutzer>({ body: request })
    }

    const testHortProCredentials = async (
        request: TestHortProCredentialsRequest
    ): Promise<TestHortProCredentialsResponse> => {
        return await useFetch({
            baseURL: '/api/nutzende/test-hort-pro-credentials'
        }).post<TestHortProCredentialsResponse>({ body: request })
    }

    const erstelleNutzer = async (request: ErstelleNutzerRequest): Promise<Nutzer> => {
        return await useFetch({
            baseURL: '/api/nutzende/erstelle'
        }).post<Nutzer>({ body: request })
    }

    const bestaetigeNutzerEmail = async (request: BestaetigeNutzerEmailRequest): Promise<Nutzer> => {
        return await useFetch({
            baseURL: '/api/nutzende/bestaetige-nutzer-email'
        }).post<Nutzer>({ body: request })
    }

    const passwortAendern = async (request: PasswortAendernRequest): Promise<Nutzer> => {
        return await useFetch({
            baseURL: '/api/nutzende/passwort-aendern'
        }).post<Nutzer>({ body: request })
    }

    const passwortZuruecksetzenAnfragen = async (request: PasswortZuruecksetzenAnfrageRequest): Promise<void> => {
        await useFetch({
            baseURL: '/api/nutzende/passwort-zuruecksetzen-anfragen'
        }).post<void>({ body: request })
    }

    const isConfirmationTokenValid = async (request: IsConfirmationTokenValidRequest): Promise<Nutzer> => {
        return await useFetch({
            baseURL: '/api/nutzende/is-confirmation-token-valid'
        }).post<Nutzer>({ body: request })
    }

    const getNutzerByIri = (iri?: Nutzer['@id'] | null) => {
        return useFetch({ baseURL: iri ?? '' }).get<Nutzer>({})
    }

    return {
        getAllNutzers,
        getNutzerById,
        getNutzerByIri,
        saveHortProCredentials,
        testHortProCredentials,
        erstelleNutzer,
        bestaetigeNutzerEmail,
        isConfirmationTokenValid,
        passwortZuruecksetzenAnfragen,
        passwortAendern
    }
}
